import * as React from "react";
const ShareIcon = ({ color = "#3293DB", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14 6.5v-4m0 0h-4m4 0L8.667 7.833m-2-4H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 5.353 2 5.913 2 7.033V11.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218h4.267c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108V9.833"
    />
  </svg>
);
export default ShareIcon;
